module.exports = __webpack_public_path__ + "static/media/google-play-badge.afd32f3d.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/google-play-badge.png
// module id = 826
// module chunks = 0